export default __webpack_public_path__ + "static/media/IMG_1415.0d4febc7.jpg";